import { Dialog, Transition } from '@headlessui/react'
import React, { Fragment, useEffect, useState } from 'react'
import OtpInput from 'react-otp-input';
import { Auth } from "aws-amplify";
import { toast } from "react-toastify";


const VerificationModal = ({ open, setOpen, userDetails }) => {
    const [otp, setOtp] = useState('');

    useEffect(() => {

    }, [])

    const resendConfirmationCode = async () => {
        try {
            await Auth.resendSignUp(userDetails?.email);
            toast.success("code resent successfully", { autoClose: 5000 });
        } catch (err) {
            toast.error(err.message, { autoClose: 5000 });
        }
    };

    // const verifyOtp = async () => {
    //     await Auth.confirmSignUp(username, authenticationCode);
    // }

    return (
        <div>
            <Transition.Root show={open} as={Fragment}>
                <Dialog as="div" className="relative z-10" onClose={setOpen}>
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0"
                        enterTo="opacity-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <div className="fixed inset-0 bg-[#c0c8d2b3]" />
                    </Transition.Child>

                    <div className="fixed inset-0 z-10 overflow-y-auto">
                        <div className="flex min-h-full justify-center p-4 text-center items-center sm:p-0">
                            <Transition.Child
                                as={Fragment}
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                                enterTo="opacity-100 translate-y-0 sm:scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            >
                                <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 w-full max-w-md">
                                    <div>
                                        <div className="font-semibold p-[16px_20px] border-b-[1px] border-[#ebeef1] text-base text-gray-900">Verification required</div>
                                        <div className="p-[16px_20px] border-b-[1px] border-[#ebeef1] text-[14px] text-[#414552] bg-[#f6f8fa]">
                                            <div>To continue, please enter the 6-digit verification code sent to <span className='cursor-pointer text-[#625afa] font-semibold'>{userDetails?.email}.</span></div>
                                            <div className='mt-5'>Didn't receive a code? <span className='cursor-pointer text-[#625afa] font-semibold' onClick={() => resendConfirmationCode()}>Resend.</span></div>
                                            <div className='my-5 otp-validation'>
                                                <OtpInput
                                                    value={otp}
                                                    onChange={setOtp}
                                                    numInputs={6}
                                                    renderSeparator={<span></span>}
                                                    renderInput={(props) => <input {...props} />}
                                                />
                                            </div>
                                        </div>
                                        <div className="font-semibold p-[16px_20px] flex justify-between text-base text-gray-900 gap-2">
                                            <button onClick={() => setOpen(false)} className="text-[#625afa] h-[30px] rounded-[6px] text-[14px] font-semibold p-[0_8px]">Cancel</button>
                                            <button className="border-[2px] h-[30px] rounded-[6px] border-[#625afa] text-white bg-[#625afa] text-[14px] font-semibold p-[0_8px]">Continue</button>
                                        </div>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </div>
                    </div>
                </Dialog>
            </Transition.Root>
        </div>
    )
}

export default VerificationModal